module.exports = __webpack_public_path__ + "static/media/team-member-06.b36bebc3.jpg";